export default "__VITE_ASSET__Dvo$us2E__"